import styled, { css } from "styled-components";
import { Box } from "./Box";

export const Container = styled(Box)`
  ${({ width, onClick, theme: { colors, spaces } }) => css`
    border-radius: 4px;
    border: 1px solid ${colors.grey.colorGrey30};
    padding: ${spaces.space30};
    background-color: ${colors.white.colorWhite};
    width: ${width ? width : "100%"};
    cursor: ${onClick ? "pointer" : "default"};
    transition: border 0.21s ease-out;
    &:hover {
      border-color: ${colors.grey.colorGrey40};
    }
  `};
`;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/spocketUI/components/Container.js